// extracted by mini-css-extract-plugin
export default {"container":"Haa-z","oos":"Iaa-z","oosUx":"Jaa-z","selected":"Kaa-z","labelOos":"Laa-z"};